import React from "react";
import { PenLine, Sun, Waves, Sparkle } from "lucide-react";

/**
 * Sticky bottom navigation for mobile only. Thumb-reachable tab switcher
 * that mirrors the top Tabs list on the Guidance page. Hidden on ≥ md.
 */
const ITEMS = [
  { value: "today",    label: "Journal",  Icon: PenLine },
  { value: "cosmic",   label: "Cosmic",   Icon: Sun },
  { value: "schumann", label: "Schumann", Icon: Waves },
  { value: "chart",    label: "Chart",    Icon: Sparkle, accent: true },
];

export default function MobileTabBar({ value, onChange }) {
  const scroll = (v) => {
    onChange(v);
    // gentle scroll to top of tab content so the user sees the new panel
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  };
  return (
    <nav
      data-testid="mobile-tab-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-[color:var(--gold)]/20 backdrop-blur-xl"
      style={{
        background: "rgba(5, 9, 23, 0.92)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <ul className="grid grid-cols-4">
        {ITEMS.map(({ value: v, label, Icon, accent }) => {
          const active = value === v;
          const color = accent ? "var(--rose-gold)" : "var(--gold)";
          return (
            <li key={v}>
              <button
                type="button"
                onClick={() => scroll(v)}
                data-testid={`mobile-tab-${v}`}
                aria-label={label}
                className="w-full flex flex-col items-center justify-center py-2.5 gap-1 relative"
              >
                <Icon
                  size={18}
                  style={{ color: active ? color : "var(--text-secondary)" }}
                />
                <span
                  className="text-[10px] tracking-wide"
                  style={{
                    color: active ? color : "var(--text-secondary)",
                    fontFamily: 'var(--font-sans, "Inter", system-ui, sans-serif)',
                  }}
                >
                  {label}
                </span>
                {active && (
                  <span
                    aria-hidden
                    className="absolute top-0 left-1/2 -translate-x-1/2 h-[2px] w-8 rounded-full"
                    style={{ background: color }}
                  />
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
